module.exports = __webpack_public_path__ + "static/img/hurixWhite2.af16451.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/hurixWhite2.png
// module id = wZ+E
// module chunks = 36